// Wrong matches are dropped: the two product names disagree on gender, on Trail vs road model,
// or on product type. Same rule as the daily mail (~/scripts/high5-fiyat-gunluk/run.py) —
// keep the two in sync.
const fold = (s) => (s || '').toLocaleLowerCase('tr').replace(/ı/g, 'i');
const gender = (s) => {
  const f = fold(s);
  return /kadin/.test(f) ? 'k' : /erkek/.test(f) ? 'e' : null;
};
const TYPES = [
  ['shoe', /ayakkab|sneaker|terlik/], ['sweat', /sweatshirt|hoodie|kapüşon|kapuson/], ['pants', /pantolon|eşofman|esofman/],
  ['tights', /tayt|tight/], ['shorts', /şort|sort\b|short/], ['tee', /t-shirt|tshirt|tişört|tisort|\btee\b|atlet|tank/],
  ['jacket', /ceket|jacket|yelek|rüzgarlık|ruzgarlik|mont/], ['socks', /çorap|corap|sock/], ['cap', /şapka|sapka|\bcap\b|bere/],
];
const ptype = (s) => { const f = fold(s); return (TYPES.find(([, re]) => re.test(f)) || [null])[0]; };
export const nameMismatch = (ours, theirs) => {
  if (!theirs) return false;
  const ga = gender(ours), gb = gender(theirs);
  if (ga && gb && ga !== gb) return true;
  if (/trail/.test(fold(ours)) !== /trail/.test(fold(theirs))) return true;
  const ta = ptype(ours), tb = ptype(theirs);
  return !!(ta && tb && ta !== tb);
};
